module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0105.png.4238329e.jpg";